import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities } from './cons-education-document-type.reducer';
import { IConsEducationDocumentType } from 'app/shared/model/cons-education-document-type.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ConsEducationDocumentType = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const consEducationDocumentTypeList = useAppSelector(state => state.consEducationDocumentType.entities);
  const loading = useAppSelector(state => state.consEducationDocumentType.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  const { match } = props;

  return (
    <div>
      <h2 id="cons-education-document-type-heading" data-cy="ConsEducationDocumentTypeHeading">
        <Translate contentKey="almobadaraMasterDataApp.consEducationDocumentType.home.title">Cons Education Document Types</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="almobadaraMasterDataApp.consEducationDocumentType.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="almobadaraMasterDataApp.consEducationDocumentType.home.createLabel">
              Create new Cons Education Document Type
            </Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {consEducationDocumentTypeList && consEducationDocumentTypeList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consEducationDocumentType.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consEducationDocumentType.code">Code</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consEducationDocumentType.name">Name</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consEducationDocumentType.nameAr">Name Ar</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consEducationDocumentType.nameEn">Name En</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consEducationDocumentType.folderName">Folder Name</Translate>
                </th>
                <th>
                  <Translate contentKey="almobadaraMasterDataApp.consEducationDocumentType.status">Status</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {consEducationDocumentTypeList.map((consEducationDocumentType, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${consEducationDocumentType.id}`} color="link" size="sm">
                      {consEducationDocumentType.id}
                    </Button>
                  </td>
                  <td>{consEducationDocumentType.code}</td>
                  <td>{consEducationDocumentType.name}</td>
                  <td>{consEducationDocumentType.nameAr}</td>
                  <td>{consEducationDocumentType.nameEn}</td>
                  <td>{consEducationDocumentType.folderName}</td>
                  <td>
                    <Translate contentKey={`almobadaraMasterDataApp.Status.${consEducationDocumentType.status}`} />
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`${match.url}/${consEducationDocumentType.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${consEducationDocumentType.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${consEducationDocumentType.id}/delete`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Archive</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="almobadaraMasterDataApp.consEducationDocumentType.home.notFound">
                No Cons Education Document Types found
              </Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default ConsEducationDocumentType;
